import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { BookingRatingDialogComponent } from './booking-rating-dialog.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable()
export class BookingRatingDialogService {
  constructor(private dialog: DialogService) {}

  open(inquiry: Inquiry, defaultRating: number = null) {
    let defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      data: { inquiry, defaultRating },
    }

    return this.dialog.openVariableDialog(BookingRatingDialogComponent, defaultConfig)
  }
}
